/**
 * Supabase 从 URL hash 解析会话后会立刻清空 hash，异步的 getSession 里再读 location.hash 会错过 type=recovery。
 * 在 React 挂载前同步记下「本次加载曾是恢复链接」，供 App 与 onAuthStateChange 使用。
 */
const KEY = 'nemolight_pw_recovery_hint_v1';

export function stashPasswordRecoveryHintFromUrl(): void {
  try {
    const raw = window.location.hash.replace(/^#/, '');
    if (raw) {
      const type = new URLSearchParams(raw).get('type');
      if (type === 'recovery') {
        sessionStorage.setItem(KEY, '1');
        return;
      }
    }
    /** PKCE 式重置邮件：链接指向本站 ?token_hash=…&type=recovery（不含 supabase.co） */
    const q = new URLSearchParams(window.location.search);
    if (q.get('type') === 'recovery' && q.get('token_hash')) {
      sessionStorage.setItem(KEY, '1');
    }
  } catch {
    /* ignore */
  }
}

export function peekPasswordRecoveryHint(): boolean {
  try {
    return sessionStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
}

export function clearPasswordRecoveryHint(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
